// Devise 認証画面用 Vite エントリポイント。
// 現状は保護者登録フォームの「選手検索」UI のみを扱う。

type Player = { id: number; name: string; furigana: string };

function initPlayerSearch(root: HTMLElement): void {
  const players: Player[] = JSON.parse(root.dataset.players || "[]");
  const initialSelected: number[] = JSON.parse(root.dataset.selectedIds || "[]");

  const chipsEl = root.querySelector<HTMLElement>("[data-player-search-chips]");
  const inputEl = root.querySelector<HTMLInputElement>("[data-player-search-input]");
  const candidatesEl = root.querySelector<HTMLElement>("[data-player-search-candidates]");
  if (!chipsEl || !inputEl || !candidatesEl) return;

  const selectedIds = new Set<number>(initialSelected.map(Number));

  const displayName = (p: Player): string =>
    (p.name && p.name.trim()) || (p.furigana && p.furigana.trim()) || "";

  const findPlayer = (id: number): Player | undefined =>
    players.find((p) => Number(p.id) === id);

  const renderChips = (): void => {
    chipsEl.innerHTML = "";
    selectedIds.forEach((id) => {
      const player = findPlayer(id);
      if (!player) return;

      const chip = document.createElement("span");
      chip.className = "player-search__chip";

      const label = document.createElement("span");
      label.className = "player-search__chip-label";
      label.textContent = displayName(player);
      chip.appendChild(label);

      const removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.className = "player-search__chip-remove";
      removeBtn.setAttribute("aria-label", `${displayName(player)}を削除`);
      removeBtn.textContent = "×";
      removeBtn.addEventListener("click", () => {
        selectedIds.delete(id);
        renderChips();
        renderCandidates(inputEl.value);
      });
      chip.appendChild(removeBtn);

      const hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = "child_user_ids[]";
      hidden.value = String(id);
      chip.appendChild(hidden);

      chipsEl.appendChild(chip);
    });
  };

  const renderCandidates = (query: string): void => {
    const trimmed = query.trim().toLowerCase();
    candidatesEl.innerHTML = "";

    if (trimmed === "") {
      candidatesEl.hidden = true;
      return;
    }

    const matches = players.filter((p) => {
      if (selectedIds.has(Number(p.id))) return false;
      const name = (p.name || "").toLowerCase();
      const furigana = (p.furigana || "").toLowerCase();
      return name.includes(trimmed) || furigana.includes(trimmed);
    });

    candidatesEl.hidden = false;

    if (matches.length === 0) {
      const empty = document.createElement("li");
      empty.className = "player-search__empty";
      empty.textContent = "該当する選手がいません";
      candidatesEl.appendChild(empty);
      return;
    }

    matches.forEach((player) => {
      const li = document.createElement("li");
      li.className = "player-search__candidate";
      li.textContent = displayName(player);
      li.addEventListener("click", () => {
        const pid = Number(player.id);
        if (selectedIds.has(pid)) return;
        selectedIds.add(pid);
        renderChips();
        inputEl.value = "";
        renderCandidates("");
        inputEl.focus();
      });
      candidatesEl.appendChild(li);
    });
  };

  inputEl.addEventListener("input", (e) => {
    renderCandidates((e.target as HTMLInputElement).value);
  });

  renderChips();
  renderCandidates("");
}

function init(): void {
  document
    .querySelectorAll<HTMLElement>("[data-player-search-root]")
    .forEach(initPlayerSearch);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
